export { default } from './PageTemplate';



// WEBPACK FOOTER //
// ./src/components/base/PageTemplate/index.js